/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { updatePlanWhenUserUpdateFromCustomComponent } from '../../store/actions';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default (props) => {
  const plansByCgp = useSelector((state) => {
    return state.sharedState.PlanReducer.plansByCgp;
  });
  const errorMessages = useSelector((state) => {
    return state.sharedState.PlanReducer.planTabData?.errorMessages;
  });
  const dispatch = useDispatch();
  const updateValueWhenUserUpdate = (data) =>
    dispatch(updatePlanWhenUserUpdateFromCustomComponent(data));
  const checkedHandler = (e) => {
    let value = e.target.value;
    let colId = props.column.colId;
    props.node.setDataValue(colId, value);
    updateValueWhenUserUpdate({ ...props.data, updateRecord: true });
  };

  return (
    <div className="form-wrapper vertical-wrapper">
      <label
        className="m-0 hide-elm"
        htmlFor={'contactId' + props.column.colId}
      >
        <span>label</span>{' '}
      </label>
      {props.value && props.value.length > 13 ? (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="filter-tooltip">{props.value || ''}</Tooltip>}
        >
          <TextField
            id={'contact_name' + props.column.colId}
            fullWidth
            className={
              errorMessages?.length > 0 && !plansByCgp[props.rowIndex]?.planName
                ? 'td-active-cell tBill-validate'
                : ''
            }
            placeholder=""
            inputProps={{ maxlength: 60, 'aria-label': 'planName' }}
            InputLabelProps={{
              shrink: true,
            }}
            value={props.value}
            onChange={checkedHandler}
            required
            disabled={!props.isEnablebyRole}
          ></TextField>
        </OverlayTrigger>
      ) : (
        <TextField
          id={'contact_name' + props.column.colId}
          fullWidth
          className={
            errorMessages?.length > 0 && !plansByCgp[props.rowIndex]?.planName
              ? 'td-active-cell tBill-validate'
              : ''
          }
          placeholder=""
          inputProps={{ maxlength: 60, 'aria-label': 'planName' }}
          InputLabelProps={{
            shrink: true,
          }}
          value={props.value}
          onChange={checkedHandler}
          required
          disabled={!props.isEnablebyRole}
        ></TextField>
      )}
    </div>
  );
};
